export type FehlerVerhalten =
  | 'anmelden'
  | 'zweiter-faktor-einrichten'
  | 'adresse-bestaetigen'
  | 'zur-liste'
  | 'feld'
  | 'kontingent'
  | 'wiederholen'
  | 'melden';

/**
 * Reihenfolge wie in Spec Abschnitt 8, und sie ist Teil des Tests: faellt ein Code aus der
 * Zwischenschicht heraus oder kommt einer hinzu, soll das hier auffallen und nicht erst,
 * wenn ein Nutzer eine nackte Meldung sieht.
 */
const TABELLE: Record<string, FehlerVerhalten> = {
  nicht_angemeldet: 'anmelden',
  adresse_nicht_bestaetigt: 'adresse-bestaetigen',
  zweiter_faktor_fehlt: 'zweiter-faktor-einrichten',
  nicht_gefunden: 'zur-liste',
  kein_objekt: 'feld',
  typ_unbekannt: 'feld',
  thema_fehlt: 'feld',
  quellurl_fremd: 'feld',
  analyse_ziel_fehlt: 'feld',
  kein_hitl: 'zur-liste',
  nicht_entscheidbar: 'zur-liste',
  runde_veraltet: 'zur-liste',
  zu_viele_laeufe: 'kontingent',
  zu_viele_abfragen: 'wiederholen',
  body_zu_gross: 'feld',
  ablage_nicht_erreichbar: 'wiederholen',
  workflow_dienst_nicht_erreichbar: 'wiederholen',
  workflow_dienst_abweisung: 'wiederholen',
  // 'zur-liste' und NICHT 'wiederholen': Zwei der drei Gruende hinter diesem Code
  // ('unerwartete_adresse' und 'zu_gross', siehe `holeVorschau` im Backend) aendern sich
  // durch Warten nie. Der Nutzer kehrt zum Lauf zurueck, wo Google Docs und Drive stehen.
  vorschau_nicht_verfuegbar: 'zur-liste',
  pdp_url_ungueltig: 'feld',
  aktion_unbekannt: 'melden',
  kein_pdp: 'zur-liste',
  zu_viele_entscheidungen: 'wiederholen',
  start_unbestaetigt: 'zur-liste',
  // Beide erreichen die Seiten nur, wenn der Willkommensdialog umgangen wurde; der Text sagt,
  // was zu tun ist.
  nutzungsbedingungen_offen: 'melden',
  nutzungsbedingungen_veraltet: 'melden',
};

export const ALLE_CODES = Object.keys(TABELLE);

export function istBekannterCode(code: string): boolean {
  return code in TABELLE;
}

export function verhaltenFuer(code: string): FehlerVerhalten {
  return TABELLE[code] ?? 'melden';
}

export const ALLGEMEINER_FEHLERTEXT =
  'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.';

export const DIENST_NICHT_ERREICHBAR_TEXT =
  'Der Dienst ist gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.';
